<template>
  <div id="invites-form-wrapper" class="vx-col m-5">
    <vx-card class="invites-form">
      <div class="vx-row no-gutter justify-center items-center">
        <div class="vx-col sm:w-full md:w-full lg:w-full">
          <div
            class="send-email invites-tabs-container flex flex-col gap-8"
            v-if="!isMailSentSuccess"
          >
            <div class="vx-card__title h-8 flex justify-center items-center">
              <h4 class="aisea-text-16-400-black">
                {{ messages.beforeSendMail.title }}
              </h4>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mw">
                <label class="vs-input--label aisea-text-14-400-dark-gray">{{
                    messages.beforeSendMail.mailAddress
                  }}</label>
                <vs-input
                  class="w-full"
                  v-model="mailAddress"
                  type="email"
                  v-validate="'required|email|min:8|max:128'"
                  :placeholder="'例)taro.aidea@aidea.biz'"
                  name="email"
                  data-vv-as="メールアドレス"
                />
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('email')"
                >{{ errors.first("email") }}</span
                >
              </div>
            </div>
            <div>
              <div class="flex justify-end">
                <vs-button
                  ref="loadableButton"
                  id="invites-button-with-loading"
                  class="
                    text-center
                    vs-con-loading__container
                    aisea-text-14-400-white
                  "
                  @click="invites"
                  :disabled="!validateForm"
                >{{ messages.beforeSendMail.send }}
                </vs-button
                >
              </div>
            </div>
          </div>

          <div
            class="after-send-email invites-tabs-container flex flex-col gap-8"
            v-else
          >
            <div class="vx-card__title h-8 flex justify-center items-center">
              <h4 class="aisea-text-16-400-dark-gray">
                {{ messages.afterSendEmail.notificationSendEmail }}
              </h4>
            </div>
            <div class="vx-row">
              <div class="vx-col w-full mw">
                <p class="aisea-text-14-400-black">
                  {{ messages.afterSendEmail.handlingError }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import {AiseaApiFactory} from "@/api/aisea/apiFactory";
import GtagService from "@/services/gtagService";

const enterpriseContractApi = AiseaApiFactory.get("enterpriseContract");

const MESSAGES = {
  beforeSendMail: {
    title: "登録したメールアドレス宛にアカウント発行用URLが送信されます。",
    placeHolder: "メールアドレスを入力",
    mailAddress: "メールアドレス",
    send: "登録",
  },
  afterSendEmail: {
    notificationSendEmail:
      "登録したメールアドレス宛にアカウント発行用URLを送信しました。",
    handlingError:
      "メールが届かない場合、メールアドレスが無効もしくは誤って登録された可能性があります。再度登録いただくか、弊社にお問い合わせください。",
  },
};

export default {
  name: "InvitesForm",
  mixins: [],
  props: {
    messages: {type: Object, default: () => MESSAGES},
  },
  components: {},
  data() {
    return {
      backgroundLoading: "primary",
      colorLoading: "#fff",
      mailAddress: "",
      isMailSentSuccess: false,
    };
  },
  computed: {
    validateForm() {
      return !this.errors.any() && this.mailAddress.length > 0;
    },
  },
  methods: {
    openLoadingContained() {
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#invites-button-with-loading",
        scale: 0.45,
      });
    },
    closeLoadingContained() {
      this.$vs.loading.close("#invites-button-with-loading > .con-vs-loading");
    },
    async invites() {
      let result = this.$validator.validateAll();
      if (result) {
        this.openLoadingContained();
        try {
          const payload = {
            email_address: this.mailAddress,
          };
          await this.applicationEnterprise(payload);
          this.successApplication();
        } catch (e) {
          this.failureApplication();
        }
      }
    },
    successApplication() {
      this.closeLoadingContained();
      setTimeout(() => {
        this.isMailSentSuccess = true;
      }, 1000);
      // Google コンバージョン アクション
      GtagService.crewProvisionalRegistration();
    },
    failureApplication() {
      this.closeLoadingContained();
      this.isMailSentSuccess = false;
    },
    async applicationEnterprise(payload) {
      return await enterpriseContractApi.applications(payload);
    },
  }
};
</script>

<style lang="scss">
@import "@/assets/scss/aisea/_variables.scss";

#invites-form-wrapper {
  .invites-form {
    max-width: 556px;
    filter: drop-shadow(0px 0px 30px rgba(112, 122, 141, 0.3));
    border-radius: 10px;

    .vx-card__body {
      padding: 2rem;
    }

    .vs-con-input-label.is-label-placeholder {
      margin-top: 30px;
    }

    .con-slot-label {
      z-index: 201;
    }

    .vs-checkbox {
      flex-shrink: 0;
    }
  }
}
</style>
